import { TrackerConfig } from "@hk01-digital/data-tracker-client"
import { createContext } from "react"

import { ResultType } from "../../constants/resultType"
import { ServicesConfig } from "../../typings/ServicesConfig"
import { parseServicesConfigFromPostMessage } from "../../utils/parameters"

export interface DataTrackingParameter {
  account_id?: string | null
  anonymous_id?: string | null
  bucket_id?: string | null
  source?: string | null
  session_id?: string | null
}

export interface SearchingParameter {
  defaultQuery?: string | null
  title?: string
}

export interface AppStateContextType {
  activeTab: ResultType | undefined
  query: string
}

export interface AppParameter extends AppStateContextType {
  indexes: ResultType[]
  trackerConfig: TrackerConfig
  trackingParameter: DataTrackingParameter
  searching: SearchingParameter
  servicesConfig: ServicesConfig
  setServicesConfig: (config: ServicesConfig) => void
}

export default createContext<AppParameter>({
  activeTab: undefined,
  query: "",
  indexes: [],
  trackerConfig: {
    GA: {
      trackingId: "",
    },
    Piwik: {
      trackingUrl: "https://track.hktester.com/v2/piwik.php",
      siteId: 5,
      userId: "empty",
    },
    webviewBridgeEnabled: false,
  },
  searching: {
    defaultQuery: "",
    title: "",
  },
  trackingParameter: {},
  servicesConfig: parseServicesConfigFromPostMessage(),
  setServicesConfig: (config: ServicesConfig) => {
    console.debug("Not implemented", config)
  },
})
